import React from "react";

import { Form, Icon, Input, Button, Checkbox, Card } from "antd";
import sgMail from "@sendgrid/mail";
const { TextArea } = Input;

sgMail.setApiKey(
  "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"
);
const Contact = () => {
  const sendMail = async (e) => {
    const msg = {
      to: "connect@talentino.live",
      from: "connect@talentino.live", // Use the email address or domain you verified above
      subject: `You have a new report from  ${e?.name}`,
      text: `email:${e?.email}  message: ${e?.message}`,
    };
    try {
      await sgMail.send(msg);
      alert("Record submitted successfully")
    } catch (error) {
      console.error(error);
      alert("Submitted success")
      if (error.response) {
        alert(JSON.stringify(error.response.body))
        console.error(error.response.body);
      }
    }
  };
  return (
    <div>
      <div style={{ padding: 15, textAlign: "center" }}>
        <h1>Have any quetion ?</h1>

        <div className="site-card-border-less-wrapper">
          <Card title="Contact" bordered={false} style={{ width: 300 }}>
            <p>+91 835692892</p>
          </Card>

          <Card title="Email" bordered={false} style={{ width: 300 }}>
            <p>connect@talentino.live</p>
          </Card>

          <Card title="Location" bordered={false} style={{ width: 300 }}>
            <p>Mumbai, maharashtra 400069</p>
          </Card>
        </div>
        <div className="site-card-border-less-wrapper">
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              width: "100%",
            }}
          >
            <Form
              name="normal_login"
              className="login-form"
              initialValues={{
                remember: true,
              }}
              onFinish={(e) => {
                sendMail(e);
              }}
            >
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input your name!",
                  },
                ]}
              >
                <Input placeholder="Enter your name" />
              </Form.Item>
              <Form.Item
                name="email"
                style={{ marginTop: 20 }}
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
              >
                <Input type="text" placeholder="Enter your email" />
              </Form.Item>
              <Form.Item
                name="message"
                style={{ marginTop: 20 }}
                rules={[
                  {
                    required: true,
                    message: "Please input your message!",
                  },
                ]}
              >
                <TextArea rows={4} placeholder="Enter your message" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                >
                  submit
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
    // <iframe
    //   src="https://docs.google.com/forms/d/e/1FAIpQLSfgGN6rXQcAzMLCBF0316JrAB7AcwKrkdyxerQ2EnfkP-eWUg/viewform?embedded=true"
    //   width="100%"
    //   height="1000"
    //   frameborder="0"
    //   marginheight="0"
    //   marginwidth="0"
    // >
    //   Loading…
    // </iframe>
  );
};
export default Contact;
